import { el } from "../lib/dom";

/**
 * View counter. POSTs to /bio-api/views on mount; the Worker increments the KV
 * counter (in prod) and returns the new count. In dev we fall back to a
 * locally-generated number so the UI still renders.
 */
export function mountViewCounter(): HTMLElement {
  const node = el("span", { class: "view-counter", "aria-live": "polite" }, [
    el("span", { class: "view-counter__eye", "aria-hidden": "true" }, ["👁"]),
    " ",
    el("span", { class: "view-counter__num" }, ["…"]),
  ]);

  const numEl = node.querySelector<HTMLElement>(".view-counter__num")!;

  fetch("/bio-api/views", { method: "POST" })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`${r.status}`))))
    .then((data: { count: number }) => {
      numEl.textContent = formatCount(data.count);
    })
    .catch(() => {
      numEl.textContent = "—";
    });

  return node;
}

function formatCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(n < 10_000 ? 1 : 0)}k`;
  return `${(n / 1_000_000).toFixed(1)}M`;
}
